/* CORESTACK-GEOM-V1 (+ FRONTE-DF 16. 10. 2026) — parametrični generator geometrije omar CoreStack (Heka Interior).
   EN vir resnice za: SVG risbo v merilu (pogled spredaj), 3D konfigurator (Three.js), AR izvoz in avtomatske teste (node).
   Brez odvisnosti; deluje v brskalniku (window.CSGeom) in v node (module.exports).

   KOORDINATE (mm): x = od leve proti desni (pogled spredaj), y = navzgor (0 = tla), z = od zadnjega roba (0) proti sprednjemu.
   Del (part): { id, k (vrsta), mat (material), b:[x0,y0,z0,x1,y1,z1], g (smer zrna 'x'|'y'|'z' za lesne dekorje),
                 inst? { type: 'handle'|'lock'|'foot'|'leg'|'castor', axis: 'x'|'y', variant } }  — inst = del, ki ga 3D lahko
                 zamenja z modelom okovja (GLB); bbox ostane za teste trkov.
   Materiali: dec (dekor modula), deck (dekor korita), blk (črna kovina, prašni lak), alu (aluminij), perf (perforirana kovina),
              pla (črna plastika), rub (guma), lin (vložek korita), soil (zemlja), cush (blazina), chr (krom).
   Konstrukcija po asortimanu (01_ASORTIMAN.md): plošča 18 mm za vse (stranice, vrh, dno, hrbet, police, vrata), rob ABS 1 mm,
   rastrska vrsta 352 mm, korpus 400 mm, z vrati 418 mm; reže med čeli 2 mm. Lukenj, veznikov in okovja v notranjosti NI
   (tehnološka dokumentacija je v MegaTischlerju) — pomembne so mere in debeline. */
(function (root, factory) {
  const G = factory();
  if (typeof module === 'object' && module.exports) module.exports = G; else root.CSGeom = G;
})(typeof self !== 'undefined' ? self : this, function () {
  'use strict';
  const C = {
    T: 18,            // debelina plošče (vse)
    TOP_PD: 25,       // vrh omare s predali
    ROW: 352,         // rastrska vrsta omar
    LROW: 450,        // vrsta osebnih omaric
    GAP: 2,           // reža med čeli
    EDGE_R: 1,        // radij zaobljenja ABS roba (1 mm)
    FRONT: 18,        // debelina naloženih vrat/čel
    SL_CLEAR: 2,      // odmik drsnih vrat od vrha/dna in od sprednjega roba
    SL_SEP: 4,        // razmik med tiroma drsnih vrat
    SL_OVER: 15,      // pol prekrivanja drsnih kril (skupaj 30 mm)
    KOR_H: 200, KOR_D: 400,
    HANDLE: { len: 178, hole: 128, w: 12, d: 34 },   // ročaj, razmik 128: dolžina 178, višina 34, širina 12 mm (cad/manifest.json)
    LOCK: { dia: 19, d: 2 },                            // cilindrična: čelo Ø19, štrli 2 mm
    LOCKL: { AP: [30, 70, 20], BP: [40, 40, 20.4], BS: [40, 80, 25.25], CS: [40, 80, 12.5], ES: [40, 80, 12.5], FS: [40, 80, 12.5] } // osebne omarice: š × v × štrlenje (cad/manifest.json)
  };
  const BASE_H = { N0: 18, NK: 100, CK: 40, CI: 100, NO: 150, KO: 80, NA: 0 };
  const OVERLAY = { V: 1, G: 1, K: 1, LN: 1, LO: 1, LM: 1, PD: 1, PL: 1 };      // naložena čela (globina korpusa = globina − 18)
  const TYPES = ['V', 'G', 'K', 'D', 'DG', 'PD', 'PL', 'R', 'LO', 'LM', 'LG', 'LN'];
  const SKU_RX = /^HK-ST-([A-Z]+?)(\d)([A-D]?)-(\d\d)-([A-Z]{2})-([A-Z0-9]{2})-([A-Z]{1,2})$/;
  // fronte (16. 10. 2026: dekor front ločeno od korpusa): krilna vrata, čela predalov, drsna vrata, vrata osebnih omaric
  const FRONT_KINDS = ['door', 'front', 'sdoor'];
  const isFront = p => FRONT_KINDS.indexOf(p.k) >= 0;
  const hasFronts = m => !!m && m.t !== 'R' && m.t !== 'LG';   // odprte police in odprta garderoba nimajo front

  function segs(m) { // razporeditev vrat lockerja od zgoraj navzdol (v vrstah po 450 mm)
    if (m.t === 'LN') return [2, 2]; if (m.t === 'LG') return [m.r];
    const r = m.r, l = m.l || 'A';
    if (l === 'B') return r === 2 ? [2] : r === 3 ? [1, 2] : [2, 2];
    if (l === 'C') return [1, 1, 2]; if (l === 'D') return [2, 1, 1];
    return Array(r).fill(1);
  }
  const isLocker = m => m.fam === 'locker' || /^L[OMGN]$/.test(m.t);
  function dims(m) {
    const F = OVERLAY[m.t] ? C.FRONT : 0, D = m.depth || (isLocker(m) ? 500 : 400);
    return { W: m.w, H: m.hmm, Dk: D - F, F, D };
  }
  // ročaj: lega središča po risbi (višina od vrha vrat: pri visokih vratih 46 % višine, sicer ≤ 250 mm)
  const handleFromTop = Hh => (Hh > 1200 ? Hh * 0.46 : Math.min(Hh / 2, 250));

  function module_(m, o) {
    o = o || {};
    const P = [], T = C.T, { W, H, Dk, F } = dims(m), h = o.h || '', add = (id, k, mat, b, x) => { P.push(Object.assign({ id, k, mat, b }, x || {})); };
    const hm = h === 'RA' ? 'alu' : 'blk', hasH = h === 'RC' || h === 'RA';
    const zf = Dk; // sprednji rob korpusa
    const topT = (m.t === 'PD' || m.t === 'PL') ? C.TOP_PD : T;
    // --- korpus
    if (topT === T) {
      add('side-l', 'side', 'dec', [0, 0, 0, T, H, Dk], { g: 'y' });
      add('side-r', 'side', 'dec', [W - T, 0, 0, W, H, Dk], { g: 'y' });
      add('bottom', 'bottom', 'dec', [T, 0, T, W - T, T, Dk], { g: 'x' });
      add('top', 'top', 'dec', [T, H - T, T, W - T, H, Dk], { g: 'x' });
      add('back', 'back', 'dec', [T, 0, 0, W - T, H, T], { g: 'y' });
    } else { // PD/PL: vrh 25 mm čez celo širino in globino (tudi nad čeli)
      add('side-l', 'side', 'dec', [0, 0, 0, T, H - topT, Dk], { g: 'y' });
      add('side-r', 'side', 'dec', [W - T, 0, 0, W, H - topT, Dk], { g: 'y' });
      add('bottom', 'bottom', 'dec', [T, 0, T, W - T, T, Dk], { g: 'x' });
      add('top', 'top', 'dec', [0, H - topT, 0, W, H, Dk + F], { g: 'x' });
      add('back', 'back', 'dec', [T, 0, 0, W - T, H - topT, T], { g: 'y' });
    }
    const shelf = (id, y, x0 = T, x1 = W - T) => add(id, 'shelf', 'dec', [x0, y, T, x1, y + T, Dk - 2], { g: 'x' });
    const doors2 = (y0, y1) => { // dvoje krilnih vrat, naložena, reža 2 mm
      const g = C.GAP, Hh = y1 - y0; // reža 2 mm ob robu, zgoraj, spodaj in v sredini: širina krila (W − 6) / 2
      add('door-l', 'door', o.doorMat || 'dec', [g, y0 + g, zf, W / 2 - g / 2, y1 - g, zf + C.FRONT], { g: 'y' });
      add('door-r', 'door', o.doorMat || 'dec', [W / 2 + g / 2, y0 + g, zf, W - g, y1 - g, zf + C.FRONT], { g: 'y' });
      const hc = y1 - handleFromTop(Hh), L = C.HANDLE;
      if (hasH) [W / 2 - 40, W / 2 + 40].forEach((cx, i) => add('handle-' + 'lr'[i], 'handle', hm, [cx - L.w / 2, hc - L.len / 2, zf + C.FRONT, cx + L.w / 2, hc + L.len / 2, zf + C.FRONT + L.d], { inst: { type: 'handle', axis: 'y', variant: h } }));
      const ly = h === 'P' ? y1 - 70 : hc + 120, lx = W / 2 - 30, R = C.LOCK.dia / 2;
      add('lock', 'lock', 'chr', [lx - R, ly - R, zf + C.FRONT, lx + R, ly + R, zf + C.FRONT + C.LOCK.d], { inst: { type: 'lock', variant: 'cyl' } });
    };
    const t = m.t;
    if (t === 'R') {
      for (let i = 1; i < m.r; i++) shelf('shelf-' + i, i * C.ROW);
      if (W > 1000) { // sredinska pokončna stena
        add('div', 'div', 'dec', [W / 2 - T / 2, T, T, W / 2 + T / 2, H - T, Dk - 2], { g: 'y' });
        // police razreži ob steni (brez prekrivanja)
        const sh = P.filter(p => p.k === 'shelf'); sh.forEach(p => { const b = p.b.slice(); p.b = [b[0], b[1], b[2], W / 2 - T / 2, b[4], b[5]]; p.id += '-l'; add(p.id.replace(/-l$/, '-r'), 'shelf', 'dec', [W / 2 + T / 2, b[1], b[2], b[3], b[4], b[5]], { g: 'x' }); });
      }
    } else if (t === 'V' || t === 'G') {
      if (t === 'V') for (let i = 1; i < m.r; i++) shelf('shelf-' + i, i * C.ROW);
      else { // garderoba: zgoraj fiksna polica, pod njo drog
        const ys = H - C.ROW - T; shelf('shelf-g', ys);
        const ry = ys - 70, rr = 12.5; add('rod', 'rod', 'chr', [T, ry - rr, Dk / 2 - rr, W - T, ry + rr, Dk / 2 + rr], { cyl: 'x' });
      }
      doors2(0, H);
    } else if (t === 'K') { // spodaj vrata (1 vrsta pri K2, sicer 2), zgoraj odprto
      const kd = m.r <= 2 ? 1 : 2;
      for (let i = 1; i < m.r; i++) shelf('shelf-' + i, i * C.ROW);
      doors2(0, kd * C.ROW + T / 2);
    } else if (t === 'D' || t === 'DG') { // drsna vrata v korpusu, dve tirnici, prekrivanje 30 mm
      if (t === 'D') for (let i = 1; i < m.r; i++) shelf('shelf-' + i, i * C.ROW, T, W - T);
      else { const ys = H - C.ROW - T; shelf('shelf-g', ys); const ry = ys - 70, rr = 12.5; add('rod', 'rod', 'chr', [T, ry - rr, Dk / 2 - 40 - rr, W - T, ry + rr, Dk / 2 - 40 + rr], { cyl: 'x' }); }
      // police in drog morajo biti za tirnicama
      const zF1 = zf - C.SL_CLEAR, zF0 = zF1 - C.FRONT, zB1 = zF0 - C.SL_SEP, zB0 = zB1 - C.FRONT;
      P.forEach(p => { if (p.k === 'shelf') p.b[5] = Math.min(p.b[5], zB0 - 2); });
      const y0 = T + C.SL_CLEAR, y1 = H - T - C.SL_CLEAR;
      add('sdoor-l', 'sdoor', 'dec', [T, y0, zB0, W / 2 + C.SL_OVER, y1, zB1], { g: 'y' });       // zadnje krilo (levo)
      add('sdoor-r', 'sdoor', 'dec', [W / 2 - C.SL_OVER, y0, zF0, W - T, y1, zF1], { g: 'y' });    // sprednje krilo (desno)
      const hh = y1 - y0, hc = y1 - Math.min(hh / 2, 260), L = C.HANDLE;
      if (hasH) [[61, zB1, 'l'], [W - 61, zF1, 'r']].forEach(([cx, z0, s]) => add('handle-' + s, 'handle', hm, [cx - L.w / 2, hc - L.len / 2, z0, cx + L.w / 2, hc + L.len / 2, z0 + L.d], { inst: { type: 'handle', axis: 'y', variant: h } }));
      const lx = W / 2 + C.SL_OVER + 12, ly = y1 - 70, R = C.LOCK.dia / 2; // na sprednjem krilu, 27 mm od njegovega roba
      add('lock', 'lock', 'chr', [lx - R, ly - R, zF1, lx + R, ly + R, zF1 + C.LOCK.d], { inst: { type: 'lock', variant: 'cyl' } });
    } else if (t === 'PD' || t === 'PL') { // predali na eni polovici, odprt predel s polico na drugi
      const half = W / 2, right = t === 'PD', yTop = H - topT;
      add('div', 'div', 'dec', [half - T / 2, T, T, half + T / 2, yTop, Dk], { g: 'y' });
      const ox0 = right ? T : half + T / 2, ox1 = right ? half - T / 2 : W - T, sy = yTop / 2 - T / 2;
      add('shelf-o', 'shelf', 'dec', [ox0, sy, T, ox1, sy + T, Dk - 2], { g: 'x' });
      const dx0 = right ? half : 0, dx1 = right ? W : half, g = C.GAP, dh = (yTop - T) / 2, L = C.HANDLE;
      for (let i = 0; i < 2; i++) {
        const fy0 = T + i * dh, fy1 = T + (i + 1) * dh;
        add('front-' + i, 'front', 'dec', [dx0 + (right ? g / 2 : g), fy0 + g / 2, zf, dx1 - (right ? g : g / 2), fy1 - g / 2, zf + C.FRONT], { g: 'x' });
        // predalnik (škatla) za čelom: stranice, hrbet, dno 18 mm; brez vodil
        const bx0 = (right ? half + T / 2 : T) + 13, bx1 = (right ? W - T : half - T / 2) - 13, by0 = fy0 + 20, by1 = fy1 - 40, bz0 = T + 20, bz1 = zf;
        add('dbox-l-' + i, 'drawer', 'dec', [bx0, by0, bz0, bx0 + T, by1, bz1], { g: 'z' });
        add('dbox-r-' + i, 'drawer', 'dec', [bx1 - T, by0, bz0, bx1, by1, bz1], { g: 'z' });
        add('dbox-b-' + i, 'drawer', 'dec', [bx0 + T, by0, bz0, bx1 - T, by1, bz0 + T], { g: 'x' });
        add('dbox-d-' + i, 'drawer', 'dec', [bx0 + T, by0, bz0 + T, bx1 - T, by0 + T, bz1], { g: 'x' });
        const hy = fy1 - 56;
        if (hasH) add('handle-' + i, 'handle', hm, [(dx0 + dx1) / 2 - L.len / 2, hy - L.w / 2, zf + C.FRONT, (dx0 + dx1) / 2 + L.len / 2, hy + L.w / 2, zf + C.FRONT + L.d], { inst: { type: 'handle', axis: 'x', variant: h } });
      }
      const R = C.LOCK.dia / 2, lx = dx1 - 50, ly = yTop - 40;
      add('lock', 'lock', 'chr', [lx - R, ly - R, zf + C.FRONT, lx + R, ly + R, zf + C.FRONT + C.LOCK.d], { inst: { type: 'lock', variant: 'cyl' } });
    } else if (t === 'LO' || t === 'LM') { // osebne omarice: predelki po razporeditvi A–D, vsak s svojimi vrati in ključavnico
      let yTopSeg = H; const sg = segs(m), g = C.GAP;
      sg.forEach((n, i) => {
        const yb = yTopSeg - n * C.LROW;
        if (i < sg.length - 1) add('shelf-' + i, 'shelf', 'dec', [T, yb - T / 2, T, W - T, yb + T / 2, Dk - 2], { g: 'x' });
        add('door-' + i, 'door', t === 'LM' ? 'perf' : 'dec', [g, yb + g / 2, zf, W - g, yTopSeg - g / 2, zf + C.FRONT], { g: 'y' });
        const dh = yTopSeg - yb, ly = yTopSeg - Math.min(dh / 2, 200), lx = W - 60;
        const L = C.LOCKL[h] || C.LOCKL.AP;
        add('lock-' + i, 'lock', /^(CS|ES|FS|BS)$/.test(h) ? 'pla' : 'chr', [lx - L[0] / 2, ly - L[1] / 2, zf + C.FRONT, lx + L[0] / 2, ly + L[1] / 2, zf + C.FRONT + L[2]], { inst: { type: 'lock', variant: h || 'AP' } });
        yTopSeg = yb;
      });
    } else if (t === 'LG') { // odprta garderoba: polica in drog
      const B = m.l === 'B', sy = B ? H - 336 - T : C.LROW - T; shelf('shelf-g', sy);
      const ry = B ? sy - 120 : H - 120 - 16, rr = 12.5; add('rod', 'rod', 'chr', [T, ry - rr, Dk / 2 - rr, W - T, ry + rr, Dk / 2 + rr], { cyl: 'x' });
    } else if (t === 'LN') { // spodaj vrata (900), zgoraj niša z blazino
      const yd = 900; shelf('shelf-n', yd - T);
      add('cush-seat', 'cush', 'cush', [T, yd, T, W - T, yd + 60, Dk - 2]);
      add('cush-top', 'cush', 'cush', [T, H - T - 30, T, W - T, H - T, Dk - 2]);
      doors2(0, yd);
    }
    return { m, W, H, Dk, F, D: Dk + F, parts: P };
  }

  // podnožje pod korpusom (y < 0 lokalno): vrne dele v koordinatah korpusa
  function base(b, W, Dk) {
    const P = [], bh = BASE_H[b] || 0, add = (id, k, mat, bb, x) => P.push(Object.assign({ id, k, mat, b: bb }, x || {}));
    if (b === 'N0') { const xs = [45, W - 45].concat(W > 1000 ? [W / 2] : []); xs.forEach((cx, i) => [45, Dk - 45].forEach((cz, j) => add(`foot-${i}${j}`, 'foot', 'pla', [cx - 15, -bh, cz - 15, cx + 15, 0, cz + 15], { inst: { type: 'foot' }, cyl: 'y' }))); }
    if (b === 'NK') { const xs = [47.5, W - 47.5].concat(W >= 1600 ? [W / 2] : []); xs.forEach((cx, i) => [45, Dk - 45].forEach((cz, j) => add(`leg-${i}${j}`, 'leg', 'blk', [cx - 30, -bh, cz - 30, cx + 30, 0, cz + 30], { inst: { type: 'leg' } }))); } // noga s ploščico 60 × 60
    if (b === 'CK') { const t = 20; add('ck-f', 'frame', 'blk', [20, -bh, Dk - 20 - t, W - 20, 0, Dk - 20]); add('ck-b', 'frame', 'blk', [20, -bh, 20, W - 20, 0, 20 + t]);
      add('ck-l', 'frame', 'blk', [20, -bh, 20 + t, 20 + t, 0, Dk - 20 - t]); add('ck-r', 'frame', 'blk', [W - 20 - t, -bh, 20 + t, W - 20, 0, Dk - 20 - t]); }
    if (b === 'CI') { const t = C.T; add('ci-f', 'plinth', 'dec', [15, -bh, Dk - 20 - t, W - 15, 0, Dk - 20], { g: 'x' }); add('ci-b', 'plinth', 'dec', [15, -bh, 20, W - 15, 0, 20 + t], { g: 'x' });
      add('ci-l', 'plinth', 'dec', [15, -bh, 20 + t, 15 + t, 0, Dk - 20 - t], { g: 'z' }); add('ci-r', 'plinth', 'dec', [W - 15 - t, -bh, 20 + t, W - 15, 0, Dk - 20 - t], { g: 'z' }); }
    if (b === 'NO') { add('no-f', 'frame', 'blk', [20, -25, Dk - 45, W - 20, 0, Dk - 20]); add('no-b', 'frame', 'blk', [20, -25, 20, W - 20, 0, 45]);
      add('no-l', 'frame', 'blk', [20, -25, 45, 45, 0, Dk - 45]); add('no-r', 'frame', 'blk', [W - 45, -25, 45, W - 20, 0, Dk - 45]);
      const xs = [[20, 45], [W - 45, W - 20]].concat(W >= 1600 ? [[W / 2 - 12.5, W / 2 + 12.5]] : []);
      xs.forEach(([x0, x1], i) => [[20, 45], [Dk - 45, Dk - 20]].forEach(([z0, z1], j) => add(`nol-${i}${j}`, 'leg', 'blk', [x0, -bh, z0, x1, -25, z1], { inst: { type: 'leg' } }))); }
    if (b === 'KO') [70, W - 70].forEach((cx, i) => [60, Dk - 60].forEach((cz, j) => add(`castor-${i}${j}`, 'castor', 'rub', [cx - 25, -bh, cz - 33, cx + 25, 0, cz + 25], { inst: { type: 'castor', brake: j === 1 } })));
    return P;
  }

  // korito za rastline na vrhu (W × 200 × globina stolpca, sprednja ploskev poravnana s čeli vrat — 15. 10. 2026): stene in dno 18 mm v dekorju, vodotesni vložek, zemlja 20 mm pod robom
  function planter(W, y0, D) {
    const T = C.T, Hk = C.KOR_H, P = [], add = (id, k, mat, b, x) => P.push(Object.assign({ id, k, mat, b }, x || {}));
    add('kor-l', 'kor', 'deck', [0, y0, 0, T, y0 + Hk, D], { g: 'z' }); add('kor-r', 'kor', 'deck', [W - T, y0, 0, W, y0 + Hk, D], { g: 'z' });
    add('kor-f', 'kor', 'deck', [T, y0, D - T, W - T, y0 + Hk, D], { g: 'x' }); add('kor-b', 'kor', 'deck', [T, y0, 0, W - T, y0 + Hk, T], { g: 'x' });
    add('kor-d', 'kor', 'deck', [T, y0, T, W - T, y0 + T, D - T], { g: 'x' });
    add('kor-lin', 'liner', 'lin', [T + 1, y0 + T, T + 1, W - T - 1, y0 + Hk - 50, D - T - 1]);
    add('kor-soil', 'soil', 'soil', [T + 1, y0 + Hk - 50, T + 1, W - T - 1, y0 + Hk - 30, D - T - 1]);
    return P;
  }

  const shift = (p, dx, dy, dz, pre) => Object.assign({}, p, { id: (pre || '') + p.id, b: [p.b[0] + dx, p.b[1] + dy, p.b[2] + dz, p.b[3] + dx, p.b[4] + dy, p.b[5] + dz] });

  /* stolpec: { base, top (0|200), td (dekor korita), stack:[{ m (modul), d (dekor korpusa), df? (dekor front; privzeto = d), h (ročaj/ključavnica) }] }
     dk dela: fronte (FRONT_KINDS) = df || d, vse ostalo (korpus, police, predalniki, cokel) = d; robovi sledijo dekorju svoje plošče
     vrne { parts (svetovne mm), W, H (skupna višina), D, items:[{m, y0, y1}] } */
  function column(col) {
    const parts = [], items = []; let y = BASE_H[col.base] || 0, W = 0, D = 0;
    col.stack.forEach((it, i) => {
      const md = module_(it.m, { h: it.h });
      if (i === 0) base(col.base, md.W, md.Dk).forEach(p => parts.push(Object.assign(shift(p, 0, y, 0, 'm0:'), { dk: it.d })));
      const df = it.df || it.d;
      md.parts.forEach(p => parts.push(Object.assign(shift(p, 0, y, 0, 'm' + i + ':'), { dk: isFront(p) ? df : it.d })));
      items.push({ m: it.m, y0: y, y1: y + md.H, Dk: md.Dk, D: md.D, h: it.h, d: it.d, df });
      y += md.H; W = Math.max(W, md.W); D = Math.max(D, md.D);
    });
    if (+col.top) { const last = items[items.length - 1]; planter(W, y, Math.max(D, C.KOR_D)).forEach(p => parts.push(Object.assign(shift(p, 0, 0, 0, 'k:'), { dk: col.td || last.d }))); y += C.KOR_H; }
    return { parts, W, H: y, D, items, base: col.base, top: +col.top || 0 };
  }

  /* stena: { cols:[ column-spec | {gap:mm} ] } → stolpci drug ob drugem (poravnani zadaj, z = 0) */
  function wall(spec) {
    let x = 0; const out = [], cols = [];
    spec.cols.forEach((c, ci) => {
      if (c.gap) { x += c.gap; return; }
      const cc = column(c); cc.parts.forEach(p => out.push(shift(p, x, 0, 0, 'c' + ci + ':'))); cols.push(Object.assign(cc, { x0: x, x1: x + cc.W })); x += cc.W;
    });
    return { parts: out, cols, W: x, H: Math.max(0, ...cols.map(c => c.H)), D: Math.max(0, ...cols.map(c => c.D)) };
  }

  function bbox(parts) {
    const b = [Infinity, Infinity, Infinity, -Infinity, -Infinity, -Infinity];
    parts.forEach(p => { for (let i = 0; i < 3; i++) { b[i] = Math.min(b[i], p.b[i]); b[i + 3] = Math.max(b[i + 3], p.b[i + 3]); } });
    return b;
  }
  // presek dveh škatel (prostornina v mm³; dotik = 0)
  function overlap(a, b) {
    let v = 1; for (let i = 0; i < 3; i++) { const d = Math.min(a[i + 3], b[i + 3]) - Math.max(a[i], b[i]); if (d <= 1e-6) return 0; v *= d; } return v;
  }
  function parseSku(sku) {
    const r = SKU_RX.exec(sku); if (!r) return null;
    return { t: r[1], r: +r[2], l: r[3] || '', wc: r[4], d: r[5], b: r[6], h: r[7] };
  }
  return { C, BASE_H, TYPES, SKU_RX, FRONT_KINDS, isFront, hasFronts, segs, dims, module: module_, base, planter, column, wall, bbox, overlap, parseSku, isLocker, handleFromTop };
});
